<template>
  <b-modal
    :no-stacking="true"
    :no-close-on-esc="onlyConfirm ? true : false"
    :hide-header-close="onlyConfirm ? true : false"
    :no-close-on-backdrop="onlyConfirm ? true : false"
    :hide-footer="onlyConfirm ? true : false"
    :hide-header="onlyConfirm ? true : false"
    :body-class="onlyConfirm ? `only-confirm` : ``"
    size="sm"
    centered
    :id="id"
    @ok="confirmAction"
    @hidden="reset"
  >
    <template #default="{ ok, cancel }" v-if="onlyConfirm">
      <div class="mt-2">
        <b-overlay
          ref="overlay"
          :show="isDisabled"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          @hidden="!isDisabled"
        >
          <b-button
            size="sm"
            variant="primary"
            @click="ok()"
            :disabled="isDisabled"
          >
            {{ okTitle }}
          </b-button>
        </b-overlay>
      </div>
      <div class="mt-2">
        <b-button size="sm" @click="cancel()" :disabled="isDisabled">
          {{ cancelTitle ? cancelTitle : `Cancel` }}
        </b-button>
      </div>
    </template>

    <template else>
      <slot></slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: ['id', 'okTitle', 'cancelTitle', 'onlyConfirm'],

  data() {
    return {
      isDisabled: false,
    }
  },

  methods: {
    confirmAction(e) {
      e.preventDefault()
      this.isDisabled = true
      if (this.onlyConfirm) {
        this.$emit('is-confirmed', true)
      }
    },
    reset() {
      this.isDisabled = false
    },
  },
}
</script>

<style lang="scss">
.btn {
  padding: 5px 10px;
}
.only-confirm {
  .btn {
    width: 100%;
    padding: 15px;
  }
}
</style>
